import React from "react";
import { makeStyles } from "@material-ui/styles";
import Typography from "@material-ui/core/Typography";

const TitleLabel = ({
  label = "No Label",
  value = "No Value",
  color = "#0F172A",
}) => {
  const boldClasses = useBoldStyles(color);
  const classes = useStyles(color);

  return (
    <span style={{ display: "flex" }}>
      <Typography classes={boldClasses}>{label}:</Typography>
      <Typography classes={classes}>{value}</Typography>
    </span>
  );
};

export default TitleLabel;

const useBoldStyles = (color) =>
  makeStyles((theme) => ({
    root: {
      color: "var(--text-primary)",
      fontWeight: "700",
    },
  }))();

const useStyles = (color) =>
  makeStyles((theme) => ({
    root: {
      color: color,
      marginLeft: ".3em",
      marginBottom: "0.5em",
    },
  }))();
